import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";

export default function EBCompnaiesNav() {
  const items = useMemo(() => {
    const navItems = [
      {
        name: "Partners List",
        to: "partner-list",
      },
      {
        name: "Training Materials",
        to: "video-knowledge-base",
      },
      {
        name: "Sales Resources",
        to: "sales-resources",
      },
      {
        name: "Marketing Resources",
        to: "marketing-resources",
      },
      {
        name: "Licenses",
        to: "licenses",
      },
      {
        name: "Blogs",
        to: "blog-management"
      },
      {
        name: "Banner",
        to: "banner-management"
      }
    ];

    return navItems;
  });

  return (
    <div className="dashboard-tabs innerpage-tabs px-4">
      <ul className="nav nav-tabs">
        {items.map((item, index) => (
          <li key={index} className="nav-item">
            {item?.type !== undefined ? (
              <NavLink className={`nav-link ga-nav-tab`} href={item.to}>
                {item.name}
              </NavLink>
            ) : (
              <NavLink className={`nav-link ga-nav-tab`} to={item.to}>
                {item.name}
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
